import { useState } from 'react';
import { exerciseImage } from '../data/exercise-types';

/**
 * The generated illustrations are optional — if the generator has not been run,
 * or a particular image failed, the component just disappears rather than
 * leaving broken image icons all over the workout screen.
 */
export function ExerciseFrames({ exerciseId }: { exerciseId: string }) {
  const [startOk, setStartOk] = useState(true);
  const [endOk, setEndOk] = useState(true);

  if (!startOk && !endOk) return null;

  return (
    <div className="exercise-frames">
      {startOk && (
        <div className="frame">
          <img
            src={exerciseImage(exerciseId, 'start')}
            alt="Starting position"
            loading="lazy"
            onError={() => setStartOk(false)}
          />
          <span className="caption">Start</span>
        </div>
      )}
      {endOk && (
        <div className="frame">
          <img
            src={exerciseImage(exerciseId, 'end')}
            alt="Finishing position"
            loading="lazy"
            onError={() => setEndOk(false)}
          />
          <span className="caption">Finish</span>
        </div>
      )}
    </div>
  );
}

export function ExerciseThumb({ exerciseId }: { exerciseId: string }) {
  const [ok, setOk] = useState(true);
  if (!ok) return <div className="exercise-thumb" aria-hidden="true" />;
  return (
    <img
      className="exercise-thumb"
      src={exerciseImage(exerciseId, 'end')}
      alt=""
      loading="lazy"
      onError={() => setOk(false)}
    />
  );
}
